// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:a8118113-5aad-42ba-abf0-a1bba64f8313",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_PyYYeFoeX",
    "aws_user_pools_web_client_id": "5upicsq5dln8s11mskqb7g9ske",
    "aws_user_files_s3_bucket": "taggered",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
